export const environment = {
  production: false,
  serverUrl: '/api',
  API_KEY_PIXABAY: ''
};
